<template>
  <div class="ma-0 pa-0">

    <!-- Snackbar d'erreur -->
    <v-snackbar v-model="snackErreur" color="red">
      {{snackMessage}}
      <v-btn text color="black" @click.native="snackErreur = false">{{ $tr.dialogCommon.close }}</v-btn>
    </v-snackbar>

    <!-- Snackbar après copie dans le presse-papiers -->
    <v-snackbar v-model="snackClipbaord" color="green text--white" timeout="2000">
      {{ $tr.purchaseOrder.dataCopiedtoClipboard }}
    </v-snackbar>

    <!-- Popup d'importation de feuilles de route prévisionnelles -->
    <importer-feuilles-route-popup ref="importerPopup" @importationTerminee="rafraichirFeuillesRoute"></importer-feuilles-route-popup>

    <!-- Popup de saisie d'une note -->
    <edit-note ref="editNote" @note-modifiee="nodeModifieeEventHandler" @note-creee="nodeCreeeEventHandler"></edit-note>

    <!-- Popup de modification d'un flux-->
    <modifier-flux-popup ref="modifierFluxPopup" @fluxmodifie="fluxmodifieEventHandler"></modifier-flux-popup>

    <!-- Popup de gestion des flux prévisionnels -->
    <gestion-flux-previsionnels-popup ref="gestionFluxPrevisionnelsPopup"></gestion-flux-previsionnels-popup>

    <!-- Popup d'affichage de la légende des couleurs -->
    <v-dialog v-model="dialogLegende" persistent :overlay="false" max-width="500px" transition="dialog-transition">
      <v-card>
        <v-card-title primary-title>
          {{ $tr.purchaseOrder.colorLegend }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr><td><img src="@/assets/flux_previsionnel.jpg" alt="Flux encours" style="border: 1px solid #E0E0E0"/></td><td><h2 style="padding-left: 10px; text-align: left">{{ $tr.purchaseOrder.f1 }}</h2></td></tr> <!-- Flux prévisionnel -->
            <tr><td><img src="@/assets/flux_couvert.jpg" alt="Flux encours"/></td><td><h2 style="padding-left: 10px; text-align: left">{{ $tr.purchaseOrder.f2 }}</h2></td></tr> <!-- Flux couvert -->
            <tr><td><img src="@/assets/flux_encours.jpg" alt="Flux encours"/></td><td><h2 style="padding-left: 10px; text-align: left">{{ $tr.purchaseOrder.f3 }}</h2></td></tr> <!-- Flux encours -->
            <tr><td><img src="@/assets/flux_ferme.jpg" alt="Flux ouvert"/></td><td><h2 style="padding-left: 10px; text-align: left">{{ $tr.purchaseOrder.f4 }}</h2></td></tr> <!-- Flux terminé -->
          </table>
          <table>
            <tr><td><img src="@/assets/date_ok.jpg" alt="Date ok"/></td><td><h2 style="padding-left: 10px; text-align: left">{{ $tr.purchaseOrder.f5 }}</h2></td></tr> <!-- Flux à l'heure -->
            <tr><td><img src="@/assets/date_retard_24.jpg" alt="Flux ouvert"/></td><td><h2 style="padding-left: 10px; text-align: left">{{ $tr.purchaseOrder.f6 }}</h2></td></tr> <!-- Flux avec 24h de retard -->
            <tr><td><img src="@/assets/date_retard_48.jpg" alt="Flux ouvert"/></td><td><h2 style="padding-left: 10px; text-align: left">{{ $tr.purchaseOrder.f7 }}</h2></td></tr> <!-- Flux avec 48h de retard -->
            <tr><td><img src="@/assets/date_retard_72.jpg" alt="Flux ouvert"/></td><td><h2 style="padding-left: 10px; text-align: left">{{ $tr.purchaseOrder.f8 }}</h2></td></tr> <!-- Flux avec au moins 72h de retard -->
          </table>
        </v-card-text>
        
        <v-card-actions>
          <v-btn text @click="dialogLegende = false">{{ $tr.dialogCommon.close }}</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>

    <!-- Popup affichage de la source -->
    <v-dialog v-model="dialogSource" scrollable  :overlay="false" max-width="900px" transition="dialog-transition">
      <v-card>
        <v-card-title primary-title>
          {{ $tr.purchaseOrder.sourceInfo }}
        </v-card-title>
        <v-card-text >
          <div>{{ $tr.purchaseOrder.sourceType }} : {{eflxSelectionne != undefined ? eflxSelectionne.eflxTypeSource : ""}}</div>
          <div>{{ $tr.purchaseOrder.source }} : {{eflxSelectionne != undefined ? eflxSelectionne.eflxSource : ""}}</div>
          <v-textarea v-model="evenementSource" rows="20">
          </v-textarea>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Popup liste des wagons -->
    <v-dialog v-model="dialogWagons" scrollable  :overlay="false" max-width="500px" transition="dialog-transition">
      <v-card>
        <v-card-title primary-title>
          {{ $tr.purchaseOrder.wagons }}
          <v-spacer></v-spacer>
          <v-btn color="success" @click="copierTableauJsonEnCsv(wagons)">{{ $tr.dialogCommon.copy }}</v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="headersWagon" dense :items-per-page="500" :items="wagons" hide-default-footer class="elevation-1" :loading="loading">
            <template v-slot:item.wgPresent="{ item }">
              <v-chip small :color="calculerCouleurWagonPresent(item.wgPresent)" dark>{{ item.wgPresent == 1 ? $tr.purchaseOrder.present : (item.wgPresent == 0 ? $tr.purchaseOrder.notPresent : "-") }}</v-chip>
            </template>            
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Popup liste des PO -->
    <v-dialog v-model="dialogPo" scrollable  :overlay="false" max-width="1200px" transition="dialog-transition">
      <v-card>
        <v-card-title primary-title>
          {{ $tr.purchaseOrder.purchaseOrders }}
          <v-spacer></v-spacer>
          <v-btn color="success" @click="copierTableauJsonEnCsv(poliste)">{{ $tr.dialogCommon.copy }}</v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="headersPo" dense :items-per-page="500" :items="poliste" hide-default-footer class="elevation-1" :loading="loading">
            <template v-slot:item.poNumero="{ item }">
              <v-btn v-if="item.poNumero != ''" :loading="caLoading" outlined color="blue" small @click="boutonChercherCodesArticles(item)">{{ item.poNumero }}</v-btn>
            </template>  
            <template v-slot:item.wgPresent="{ item }">
              <v-chip small :color="calculerCouleurWagonPresent(item.wgPresent)" dark>{{ item.wgPresent == 1 ? $tr.purchaseOrder.present : (item.wgPresent == 0 ? $tr.purchaseOrder.notPresent : "-") }}</v-chip>
            </template>  
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Popup liste des codes articles -->
    <v-dialog v-model="dialogCa" scrollable  :overlay="false" max-width="1200px" transition="dialog-transition">
      <v-card>
        <v-card-title primary-title>
          {{ $tr.purchaseOrder.articles }}
          <v-spacer></v-spacer>
          <v-btn color="success" @click="copierTableauJsonEnCsv(caliste)">{{ $tr.dialogCommon.copy }}</v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="headersCa" dense :items-per-page="500" :items="caliste" hide-default-footer class="elevation-1" :loading="loading">
            <template v-slot:item.caDateDocument="{ item }">
              {{ item.caDateDocument.substr(0, 10) }}
            </template>  
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" text @click="dialogCa = false">{{ $tr.dialogCommon.close }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Popup visu des alertes infos -->
    <v-dialog v-model="dialogAi" scrollable  :overlay="false" max-width="1200px" transition="dialog-transition">
      <v-card>
        <v-card-title primary-title>
          <h-group style="width: 100%">
            <div>{{ $tr.purchaseOrder.infoAlert }}</div>
            <v-spacer></v-spacer>
            <v-btn text color="blue" @click="ajouterAlerteInfoClickHandler" v-if="$USER_SUIVITRAINMANAGER"><v-icon left>mdi-plus</v-icon>{{ $tr.dialogCommon.add }}</v-btn>
          </h-group>
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="headersAi" dense :items-per-page="500" :items="alertesInfos" hide-default-footer class="elevation-1" :loading="loading">
            <template v-slot:item.aiDate="{ item }">
              <div>{{ formatDate(item.aiDate) + ' ' + formatHeure(item.aiDate) }}</div>
            </template>            
            <template v-slot:item.aiMessage="{ item }">
              <div style="max-width: 500px;" class="red--text">{{ item.aiMessage }}</div>
            </template>            
            <template v-slot:item.aiDateEcheance="{ item }">
              <div>{{ formatDate(item.aiDateEcheance) }}</div>
            </template>            
            <template v-slot:item.boutons="{ item }">
              <v-btn text color="error" @click="supprimerAlerteInfo(item.aiAiId)"><v-icon left>mdi-delete</v-icon>{{ $tr.dialogCommon.delete }}</v-btn>
            </template>            
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogAi = false">{{ $tr.dialogCommon.close }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Popup ajout d'une alerte info -->
    <v-dialog v-model="dialogAjouterAi" scrollable  :overlay="false" max-width="1200px" transition="dialog-transition">
      <v-card>
        <v-card-title primary-title>
          {{ $tr.purchaseOrder.addInfoAlert }}
        </v-card-title>
        <v-card-text>
          <v-lazy>
            <v-text-field :label="$tr.purchaseOrder.message" ref="refAlerteInfoMessage" autofocus  maxlength="250"></v-text-field>
          </v-lazy>
          <h-group>
            <v-menu v-model="datepickerAiEcheanceMenu" :close-on-content-click="false" offset-y max-width="290px" min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="datepickerAiSEcheance" :label="$tr.purchaseOrder.dueDate" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" v-on="on" style="max-width: 250px" class="mx-3"></v-text-field>
              </template>
              <v-date-picker v-model="datepickerAiEcheance" no-title @input="choixJourDateEchanceAlerteInfo"></v-date-picker>
            </v-menu>

            <v-text-field :label="$tr.purchaseOrder.priority" type="number" class="shrink" v-model="prioriteAi"></v-text-field>
          </h-group>

        </v-card-text>
        
        <v-card-actions>
          <v-btn color="success"  @click="validerAlerteInfoClickHandler">{{ $tr.dialogCommon.validate }}</v-btn>
          <v-btn text @click="dialogAjouterAi = false">{{ $tr.dialogCommon.cancel }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>    
    
    <!-- Tablulation pour les 2 onglets de la vue -->
    <h-group style="flex-flow: nowrap;">
      <v-tabs v-model="tab" align-with-title height="20px">
        <v-tabs-slider color="yellow"></v-tabs-slider>

        <!-- Suivi des flux -->
        <v-tab @change="rafraichirFeuillesRoute">
          {{ $tr.purchaseOrder.tab1 }}
        </v-tab>

        <!-- Prévisionnel de livraison des PO -->
        <v-tab @change="rechercherPurchaseOrder">
          {{ $tr.purchaseOrder.tab2 }}
        </v-tab>
      </v-tabs>

      <v-btn x-small color="success" @click="dialogLegende = true">{{ $tr.purchaseOrder.legend }}</v-btn>

    </h-group>

    <v-tabs-items v-model="tab">

      <!--                                    -->
      <!-- Onglet "Suivi des flux"            -->
      <!--                                    -->
      <v-tab-item class="mt-2" >
        <div ref="vuepo" style="width: 1880px; height: 750px; overflow: hidden; transform-origin: top left;">
          <!-- Filtres --> 
          <div class="mb-1" style="text-align: left; width: 1860px; text-wrap: nowrap; padding: 2px 5px 2px 5px;background-color: rgb(147, 22, 22); display: inline-block;">
            <!-- Nombre de jours avant et après -->
            <div style="display: inline-block; ">
              <v-select style="width: 80px" class="mr-3" @input="rafraichirFeuillesRoute" :items="[-10, -20, -30, -60, -90, -180, -365, -3650]" v-model="filtreJoursAmont" dark dense hide-details></v-select>
              <v-select style="width: 80px" class="mr-3" @input="rafraichirFeuillesRoute" :items="['+10', '+20', '+30', '+60', '+90', '+180', '+365', '+3650']" v-model="filtreJoursAval" dark dense hide-details></v-select>
            </div>
            <div style="display: inline-block; color: white">j.</div>

            <!-- Choix du tri croissant / décroissant pour les dates -->
            <v-radio-group v-model="filtreTriDate" dense hide-details style="margin-top: 0; display: inline-block; margin-left: 10px">
              <v-radio dark :label="$tr.timeCommon.descDate" dense hide-details value="1"  @click="rafraichirFeuillesRoute">
                <template v-slot:label><div style="color: white">{{ $tr.timeCommon.descDate }}</div></template>
              </v-radio>
              <v-radio dark :label="$tr.timeCommon.ascDate" value="2" dense hide-details @click="rafraichirFeuillesRoute">
                <template v-slot:label><div style="color: white">{{ $tr.timeCommon.ascDate }}</div></template>
              </v-radio>
            </v-radio-group>              

            <!-- Choix des statuts -->
            <div style="display: inline-block; margin-left: 10px;" >
              <div>
                <v-checkbox x-small dark hide-details dense v-model="afficherFluxPrevisionnels" @click="rafraichirFeuillesRoute" style="display: inline-block" >
                  <template v-slot:label><div class="filtreTexteStatut">{{ $tr.purchaseOrder.status1 }}</div></template> <!-- Prévisionnels -->
                </v-checkbox>
                <v-checkbox dark hide-details dense v-model="afficherFluxOuverts" @click="rafraichirFeuillesRoute"  style="display: inline-block" >
                  <template v-slot:label><div class="filtreTexteStatut">{{ $tr.purchaseOrder.status2 }}</div></template> <!-- Ouverts -->
                </v-checkbox>
                <v-checkbox dark hide-details dense v-model="afficherFluxFermes" @click="rafraichirFeuillesRoute"  style="display: inline-block" >
                  <template v-slot:label><div class="filtreTexteStatut">{{ $tr.purchaseOrder.status3 }}</div></template> <!-- Fermés -->
                </v-checkbox>
              </div>
              <div>
                <v-checkbox dark hide-details dense v-model="afficherFluxAnnules" @click="rafraichirFeuillesRoute"  style="display: inline-block" >
                  <template v-slot:label><div class="filtreTexteStatut">{{ $tr.purchaseOrder.status4 }}</div></template> <!-- Annulés -->
                </v-checkbox>
                <v-btn color="success" x-small class="mt-2 ml-3" @click="boutonAucunFiltreStatut" style="display: inline-block" >{{ $tr.dialogCommon.none }}</v-btn>
                  <v-btn color="success" x-small class="mt-2 ml-3" @click="boutonToutFiltreStatut" style="display: inline-block" >{{ $tr.dialogCommon.all }}</v-btn>
              </div>
            </div>

            <!-- Filtre sur le lieu de départ -->
            <v-text-field dark style="width: 150px;display: inline-block;" class="ml-4 mr-2" clearable name="name" :label="$tr.purchaseOrder.departurePlace" v-model="lieuDepartRecherchee"></v-text-field>

            <!-- Bouton d'appel des trajets mémorisés-->
            <v-menu bottom :close-on-click="false" :close-on-content-click="false" v-model="menuTrajets" style="display: inline-block;">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" text icon color="#00FF00" small><v-icon>mdi-ray-start-arrow</v-icon></v-btn>
              </template>
              <v-list dense hide-details style="overflow: auto; max-height: 500px;">
                <v-list-item dense hide-details link v-for="(trajet, index) in trajets" :key="index">
                  <v-list-item-content  dense hide-details @click="rafraichirTrajet(trajet)" style="padding: 0;margin: 0;">
                    {{ trajet }}
                  </v-list-item-content>
                  <v-list-item-action style="padding: 0;margin: 0;"><v-btn  style="padding: 0;margin: 0;" icon text color="green" @click="descendreTrajet(trajet)"><v-icon>mdi-arrow-down-thin</v-icon></v-btn></v-list-item-action>
                  <v-list-item-action style="padding: 0;margin: 0;"><v-btn  style="padding: 0;margin: 0;" icon text color="green" @click="monterTrajet(trajet)"><v-icon>mdi-arrow-up-thin</v-icon></v-btn></v-list-item-action>
                  <v-list-item-action style="padding: 0;margin: 0;"><v-btn  style="padding: 0;margin: 0;" icon text color="red" @click="supprimerTrajet(trajet)"><v-icon>mdi-alpha-x</v-icon></v-btn></v-list-item-action>
                </v-list-item>
              </v-list>
            </v-menu>

            <!-- Filtre sur le lieu d'arrivée -->
            <v-text-field dark style="width: 150px;display: inline-block;" clearable class="mr-3 ml-1" name="name" :label="$tr.purchaseOrder.arrivalPlace" v-model="lieuArriveeRecherchee"></v-text-field>

            <!-- Filtre sur la référence -->
            <v-text-field dark style="width: 150px; display: inline-block;" clearable class="mr-3" name="name" :label="$tr.purchaseOrder.reference" v-model="referenceRecherchee" ></v-text-field>

            <div style="padding-top: 0px; display: inline-block;">
              <!-- Bouton Rafraichir -->
              <v-tooltip bottom  style="display: inline-block;"><template v-slot:activator="{ on, attrs }">
                <v-btn color="success" @click="rafraichirFeuillesRoute" v-if="$USER_SUIVITRAINMANAGER" dark small v-bind="attrs" v-on="on" :loading="loading" ><v-icon dark>mdi-refresh</v-icon></v-btn>            
              </template><span>{{ $tr.purchaseOrder.refreshBtn }}</span></v-tooltip> <!-- Rafraichir la liste -->

              <!-- Bouton Importer -->
              <v-tooltip bottom style="display: inline-block;"><template v-slot:activator="{ on, attrs }">
                <v-btn color="success" class="ml-2" @click="importerFeuillesRoute" v-if="$USER_SUIVITRAINMANAGER" dark small v-bind="attrs" v-on="on"><v-icon dark>mdi-import</v-icon></v-btn>            
              </template><span>{{ $tr.purchaseOrder.importBtn }}</span></v-tooltip> <!-- Importer des flux prévisionnels -->

              <!-- Bouton gestion des flux prévisionnels -->
              <v-tooltip bottom style="display: inline-block; padding-top: 25px;"><template v-slot:activator="{ on, attrs }">
                <v-btn color="success" class="ml-2" @click="boutonOuvrirFluxPrevisionnelsClickEventHandler" v-if="$USER_SUIVITRAINMANAGER" dark small v-bind="attrs" v-on="on"><v-icon dark>mdi-eye</v-icon></v-btn>
              </template><span>{{ $tr.purchaseOrder.seeBtn }}</span></v-tooltip> <!-- Voir et gérer les flux prévisionnels -->
            </div>

            <!-- Alerte infos -->
            <div class="mb-1" style="text-align: center; text-wrap: nowrap; padding: 2px 2px 5px 5px; display: inline-block; font-weight: bold; cursor: pointer; width:634px !important; overflow: hidden;background-color: #F0F0F0; color: red; height: 70px; margin-left: 10px;" @click="dialogAi = true">
              <div v-if="alertesInfos.length > 0" style="flex: 1; text-align: center; text-wrap: auto;" @click="dialogAi = true">{{ alertesInfos[alertesInfosIndex].aiMessage }}</div>
              <div v-if="alertesInfos.length == 0" style="color: #C0C0C0; flex: 1; text-align: center;" @click="dialogAi = true">{{ $tr.purchaseOrder.noInfoAlert }}</div>
            </div>
          </div>

          <v-progress-linear v-if="loading" indeterminate color="#961616"></v-progress-linear>

          <div style="overflow: auto; height: 730px;" class="green lighten-5" >
            <!--                              -->
            <!-- Cadre d'une feuille de route -->
            <!--                              -->
            <v-expansion-panels class="mb-6 pa-1" multiple>
              <v-expansion-panel v-for="(fr, indexFr) in frs" :key="indexFr" class="mb-1" elevation="2" style="width: 100%" >
                
                <!-- Entête de la feuille de route -->
                <v-expansion-panel-header primary-title expand-icon="mdi-menu-down" :color="getFrColor(fr)" class="px-2 py-1">
                  <template v-slot:actions>
                    <v-icon v-if="fr.nt.length > 0" color="error">mdi-alert-circle</v-icon>
                  </template>

                  <div style="text-wrap: nowrap;">

                    <!-- Lieu plus date de départ -->
                    <div class="mr-4" style="width: 270px; display: inline-block; text-align: center;">
                      <div class="titreValeur">{{getLieu(fr.frDepartLieu)}}</div>
                      <h5 class="mb-1">{{fr.frDepartLieu}}</h5>
                      <div class="titreValeur">{{formatDate(fr.frDepartDateTheorique)}}</div>
                    </div>

                    <!-- Date de départ -->
                    <div style="display:inline-block" class="mr-4">
                      <div class="mb-1" style="text-align: center">{{ $tr.purchaseOrder.departureDate }}</div>
                      <div :class="'dateReelle ' + calculerClasseDateReelle(fr.frDepartDateTheorique, fr.frDepartDateReelle)">
                        <div v-if="fr.frDepartDateReelle == undefined">{{formatDate(fr.frDepartDateTheorique)}}</div>
                        <div v-if="fr.frDepartDateReelle != undefined">{{formatDate(fr.frDepartDateReelle)}} {{formatHeure(fr.frDepartDateReelle)}}</div>
                      </div>
                      <div class="motifAnnulation" v-if="fr.frStatut == $FLUX_STATUT_ANNULE">{{ $tr.purchaseOrder.CANCELLED }} : {{ fr.frMotifAnnulation }}</div>
                    </div>
                    
                    <!-- Référence et boutons de visualisation des wagons et PO -->
                    <div style="align-items: center; display: inline-block; text-align: center; width: 320px" class="mr-0">
                      <div class="mb-2">{{fr.frReference}}&nbsp;&nbsp;<span style="font-size:14px">id:{{fr.frId}}</span></div>
                      <div class="mb-1">
                        <div class="mr-2" style="display: inline-block">{{fr.po.length}}</div>
                        <v-btn text color="blue" outlined @click="lirePo(fr)" style="display: inline-block">PO{{fr.po.length > 1 ? 's' : ''}}</v-btn>
                        <div class="mr-2 ml-8" style="display: inline-block">{{fr.wg.length}}</div>
                        <v-btn text color="blue" outlined @click="lireWagons(fr)" style="display: inline-block">wagon{{fr.wg.length > 1 ? 's' : ''}}</v-btn>
                      </div>
                    </div>                
                    
                    <!-- Wagons ok ? -->
                    <div style="display: inline-block; width: 80px;">
                      <div style="color: red; text-align: center;" v-if="computeWagonNOK(fr)">WAGONS</div>
                    </div>

                    <!-- bouton ajouter une note -->
                    <div style="display: inline-block; width: 140px; text-align: center;" class="mr-4">
                      <v-switch :loading="fr.statutLoading" v-if="fr.frStatut <= $FLUX_STATUT_COUVERT" class="ml-4 mt-3 mr-4" :label="`${fr.statutCouvert ? 'Couvert' : 'Non couvert'}`" v-model="fr.statutCouvert" @click="boutonFluxCouvert($event, fr, indexFr)" ></v-switch>
                      <v-btn small outlined @click="ajouterModifierNoteClickHandler($event, undefined, fr.frId)" v-if="$USER_SUIVITRAINMANAGER" ><v-icon left>mdi-plus</v-icon>{{ $tr.purchaseOrder.note }}</v-btn>
                    </div>

                    <!-- Date d'arrivée -->
                    <div class="mr-4" style="display: inline-block; text-align: center">
                      <div class="mb-1" style="text-align: center">{{ $tr.purchaseOrder.arrivalDate }}</div>
                      <div :class="'dateReelle ' + calculerClasseDateReelle(fr.frArriveeDateTheorique, fr.frArriveeDateReelle)">
                        <div v-if="fr.frArriveeDateReelle == undefined">{{formatDate(fr.frArriveeDateTheorique)}}</div>
                        <div v-if="fr.frArriveeDateReelle != undefined">{{formatDate(fr.frArriveeDateReelle)}} {{formatHeure(fr.frArriveeDateReelle)}}</div>
                      </div>
                    </div>

                    <!-- Lieu plus date d'arrivée -->
                    <div style="width: 250px;display: inline-block; text-align: center">
                      <div class="titreValeur">{{getLieu(fr.frArriveeLieu)}}</div>
                      <h5 class="mb-3">{{fr.frArriveeLieu}}</h5>
                      <div class="titreValeur">{{formatDate(fr.frArriveeDateTheorique)}}</div>
                    </div>
                  </div>
                </v-expansion-panel-header>

                <!-- Liste des trains de la feuille de route -->
                <v-expansion-panel-content>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>Id</th>
                          <th>{{ $tr.purchaseOrder.rc1 }}</th> <!-- Prestataire -->
                          <th>{{ $tr.purchaseOrder.rc2 }}</th> <!-- Trajet -->
                          <th><div style="display: inline" class="mr-2"><v-icon small>mdi-arrow-expand-right</v-icon></div>{{ $tr.purchaseOrder.rc3 }}</th> <!-- départ théorique et réelle -->
                          <th>{{ $tr.purchaseOrder.rc4 }}<div style="display: inline" class="ml-2"><v-icon small>mdi-arrow-collapse-right</v-icon></div></th> <!-- arrivée théorique et réelle -->
                          <th>{{ $tr.purchaseOrder.rc5 }}</th> <!-- Contrôle -->
                          <th>{{ $tr.purchaseOrder.rc6 }}</th> <!-- Note -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="train in fr.tr" :key="train.trId">
                          <td>{{train.trId}}</td>
                          <td>{{train.trPrestataire}}</td>
                          <td>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on">{{train.trDepartLieu}}-{{train.trArriveeLieu}}</div>
                              </template>
                              <span>{{lireTrajet(train.trDepartLieu, train.trArriveeLieu)}}</span>
                            </v-tooltip>
                          </td>

                          <!-- Date/heure de départ théorique et réelle -->
                          <td>
                            <h-group>
                              <div class="ml-2 mr-2">{{ $tr.purchaseOrder.expected }}<br/>{{ $tr.purchaseOrder.real }}</div>
                              <div style="padding: 3px;min-width: 250px;" :class="calculerClasseDateReelle(train.trDepartDateTheorique, train.trDepartDateReelle, 4, 8)">{{formatDateHeure(train.trDepartDateTheorique)}}<br/>{{formatDateHeure(train.trDepartDateReelle)}}</div>
                            </h-group>
                          </td>

                          <!-- Date/heure d'arrivée théorique et réelle -->
                          <td>
                            <h-group>
                              <div class="ml-2 mr-2">{{ $tr.purchaseOrder.expected }}<br/>{{ $tr.purchaseOrder.real }}</div>
                              <div style="padding: 3px;min-width: 250px;" :class="calculerClasseDateReelle(train.trArriveeDateTheorique, train.trArriveeDateReelle, 4, 8)">{{formatDateHeure(train.trArriveeDateTheorique)}}<br/>{{formatDateHeure(train.trArriveeDateReelle)}}</div>
                            </h-group>
                          </td>

                          <!-- Contrôle wagons -->
                          <td>
                            <div >
                              <v-btn text :color="calculerCouleurControleWagons(train.trControleWagonsOk)" @click="lireWagons(fr)">
                                <v-icon left :color="calculerCouleurControleWagons(train.trControleWagonsOk)">mdi-train-car-container</v-icon>
                                {{ $tr.purchaseOrder.wagons }}
                              </v-btn>
                            </div>
                          </td>

                          <td>{{train.trNote}}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <!-- Liste des notes de la feuille de route -->
                  <div v-for="nt in fr.nt" :key="nt.ntId">
                    <h6 style="margin-bottom: 0px; text-align: left">{{ $tr.purchaseOrder.createdAt }} {{formatDateHeure(nt.ntDateCreation)}} <span v-if="nt.ntDateModification != null"> - {{ $tr.purchaseOrder.updatedAt }} {{formatDateHeure(nt.ntDateModification)}}</span> <span>{{ $tr.purchaseOrder.by }} {{nt.ntAuteur}}</span></h6>
                    <h-group>
                      <div v-html="nt.ntNote" class="note"></div>
                      <v-btn color="success" fab x-small dark class="ma-2" @click="ajouterModifierNoteClickHandler($event, nt, nt.ntFrId)" v-if="$USER_SUIVITRAINMANAGER"><v-icon>mdi-pencil</v-icon></v-btn>
                      <v-btn color="error" fab x-small dark class="ma-2" @click="supprimerNoteClickHandler(nt.ntId)" v-if="$USER_SUIVITRAINMANAGER"><v-icon>mdi-delete</v-icon></v-btn>
                    </h-group>
                  </div>
                  <v-btn text @click="ajouterModifierNoteClickHandler($event, undefined, fr.frId)" v-if="$USER_SUIVITRAINMANAGER"><v-icon left>mdi-plus</v-icon>{{ $tr.purchaseOrder.addNoteBtn }}</v-btn>

                  <v-btn class="ml-10" text @click="fermerFeuilleRouteClickHandler(fr)" v-if="$USER_SUIVITRAINMANAGER"><v-icon left color="red">mdi-close</v-icon>{{ $tr.purchaseOrder.editFlowBtn }}</v-btn>

                </v-expansion-panel-content>

              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-tab-item>

      <!--                                    -->
      <!-- Onglet "Prévisionnel de livraison des PO            -->
      <!--                                    -->
      <v-tab-item class="mt-2">
        <!-- Filtres -->
        <v-toolbar color="cyan" dark flat>
          <v-toolbar-title>{{ $tr.purchaseOrder.purchaseOrder }}</v-toolbar-title>


          <template v-slot:extension>
            <div style="display: inherit;">

              <!-- Date de début -->
              <v-menu v-model="menuDateDebut" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">            
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="filtreDateDebut" :label="$tr.dialogCommon.beginDate" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="filtreDateDebut" @input="menuDateDebut = false"/>
              </v-menu>

              <!-- Date de fin -->
              <v-menu v-model="menuDateFin" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">            
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="filtreDateFin" :label="$tr.dialogCommon.endDate" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="filtreDateFin" @input="menuDateFin = false"/>
              </v-menu>
              
              <!-- Produit -->
              <v-text-field v-model="filtreProduit" class="mx-2" clear-icon="mdi-close-circle" clearable :label="$tr.purchaseOrder.product" style="width: 200px"></v-text-field>

              <!-- PO -->
              <v-text-field v-model="filtrePO" class="mx-2" clear-icon="mdi-close-circle" clearable :label="$tr.purchaseOrder.PO"></v-text-field>

              <!-- Wagons vides ? -->
              <v-checkbox label="Inclure wagons vides" class="mx-2" v-model="poInclureWagonsVides"></v-checkbox>

              <v-btn color="success" class="ml-2 mr-5" @click="boutonRechercherPurchaseOrderClick" :loading="loading">{{ $tr.dialogCommon.refresh }}</v-btn>
              <v-btn color="success" @click="boutonExporterPurchaseOrderClick" :loading="loading">{{ $tr.dialogCommon.export }}</v-btn>
            </div>
          </template>
        </v-toolbar>

        <!-- Liste des purchase orders par date de livraison -->
        <v-card elevation="5" class="grey lighten-5 my-2">
          <v-card-text elevation-10>
            <v-text-field v-model="poSearch" clear-icon="mdi-close-circle" clearable append-icon="mdi-magnify" :label="$tr.purchaseOrder.searchInList" class="mx-4" style="width: 500px" single-line hide-details></v-text-field>
            <v-data-table dense :loading="loading" :headers="headersPurchaseOrders" hide-details :items="purchaseOrders" item-key="index" height="520px" fixed-header
                multi-sort :sort-by="['frArriveeDateTheorique']" :sort-desc="true" class="elevation-1 mt-3" :search="poSearch" :items-per-page="10000">
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

  </div>  

</template>


<script>
import axios from 'axios';
import HGroup from '@/components/flex/HGroup.vue';
import EditNote from '@/views/suivitrains/EditNote.vue'
import Vue from 'vue'
import { json2excel } from 'js2excel';
import ImporterFeuillesRoutePopup from '@/components/popup/ImporterFeuillesRoutePopup.vue'
import ModifierFluxPopup from '@/components/popup/ModifierFluxPopup.vue'
import GestionFluxPrevisionnelsPopup from '@/components/popup/GestionFluxPrevisionnelsPopup.vue'

export default {
  components: {HGroup, EditNote,ImporterFeuillesRoutePopup, ModifierFluxPopup, GestionFluxPrevisionnelsPopup },

  data() {
    return {
      tab: 0,
      loading: false,
      snackErreur: false,
      snackMessage: "",
      fluxes: [],
      snackClipbaord: false,
      menuTrajets: false,

      poSearch: "",
      headersPurchaseOrders: [
         { text: this.$tr.purchaseOrder.poc1, value: 'poProduit' }, //Produit
         { text: this.$tr.purchaseOrder.poc2, value: 'poNumero' }, //PO
         { text: this.$tr.purchaseOrder.poc3, value: 'caCodeArticle' }, //Article
         { text: this.$tr.purchaseOrder.poc4, value: 'caDescription' }, //Description
         { text: this.$tr.purchaseOrder.poc5, value: 'poNbPalettes' }, //Nb palettes
         { text: this.$tr.purchaseOrder.poc6, value: 'poPoids' }, //Poids
         { text: this.$tr.purchaseOrder.poc7, value: 'poNumeroWagon' }, //Wagon
         { text: this.$tr.purchaseOrder.poc8, value: 'poNote' }, //Note
         { text: this.$tr.purchaseOrder.poc9, value: 'poLieuChargement' }, //Lieu chargement
         { text: this.$tr.purchaseOrder.poc10, value: 'frDepartLieu' }, //Départ
         { text: this.$tr.purchaseOrder.poc11, value: 'frDepartDateTheorique' }, //Prévu
         { text: this.$tr.purchaseOrder.poc12, value: 'frDepartDateReelle' }, //Réel
         { text: this.$tr.purchaseOrder.poc13, value: 'frArriveeLieu' }, //Arrivée
         { text: this.$tr.purchaseOrder.poc14, value: 'frArriveeDateTheorique' }, //Prévus
         { text: this.$tr.purchaseOrder.poc15, value: 'frArriveeDateReelle' }, //Réel
         { text: this.$tr.purchaseOrder.poc16, value: 'frReference' } //Référence
      ],

      frs: [],
      purchaseOrders:[],
      filtreJoursAmont: 10,
      filtreJoursAval: '+10',
      headersEvenements: [
         { text: this.$tr.purchaseOrder.evtc1, value: 'eflxDate' }, //Date
         { text: this.$tr.purchaseOrder.evtc2, value: 'eflxLieu' }, //Trajet
         { text: this.$tr.purchaseOrder.evtc3, value: 'eflxType' }, //Type
         { text: this.$tr.purchaseOrder.evtc4, value: 'eflxNiveauAlerte' }, //Niveau
         { text: this.$tr.purchaseOrder.evtc5, value: 'eflxInfoPrestataire' }, //Info. prestataire
         { text: this.$tr.purchaseOrder.evtc6, value: 'eflxInfoFlux' } //Info. flux
      ],
      dialogPo: false,
      headersPo: [
         { text: this.$tr.purchaseOrder.hpoc1, value: 'poProduit' }, //Produit
         { text: this.$tr.purchaseOrder.hpoc2, value: 'poNumero' }, //PO
         { text: this.$tr.purchaseOrder.hpoc3, value: 'poNbPalettes' }, //Nb palettes
         { text: this.$tr.purchaseOrder.hpoc4, value: 'poPoids' }, //Poids
         { text: this.$tr.purchaseOrder.hpoc5, value: 'poLieuChargement' }, //Lieu de chargement
         { text: this.$tr.purchaseOrder.hpoc6, value: 'poNumeroWagon' }, //Wagon
         { text: '', value: 'wgPresent' },
         { text: this.$tr.purchaseOrder.hpoc7, value: 'poNote' } //Note
      ],
      poliste: [],
      dialogCa: false,
      headersCa: [
        { text: this.$tr.purchaseOrder.cac1, value: 'caPoNumero' },     //PO
        { text: this.$tr.purchaseOrder.cac7, value: 'caNumeroBesoin' }, // Numéro de besoin
        { text: this.$tr.purchaseOrder.cac2, value: 'caCodeArticle' },  // Code article
        { text: this.$tr.purchaseOrder.cac3, value: 'caDateDocument' }, // Date document
        { text: this.$tr.purchaseOrder.cac4, value: 'caQuantite' },     // Quantité
        { text: this.$tr.purchaseOrder.cac5, value: 'caUnite' },        // Unité
        { text: this.$tr.purchaseOrder.cac6, value: 'caDescription' }   // Description
      ],
      caliste: [],
      caLoading: false,

      headersWagon: [
         { text: this.$tr.purchaseOrder.wc1, value: 'wgNumero' }, //Numéro
         { text: '', value: 'wgPresent'}
      ],
      dialogWagons: false,
      wagons: [],

      dialogSource: false,
      eflxSelectionne: undefined,
      evenementSource: "",

      referenceRecherchee: "",
      lieuDepartRecherchee: "",
      lieuArriveeRecherchee: "",

      filtreTriDate: '2',
      dialogLegende: false,

      filtreDateDebut: new Date().toISOString().substr(0,10),
      menuDateDebut: false,
      filtreDateFin: new Date().toISOString().substr(0,10),
      menuDateFin: false,
      filtreProduit: "",
      filtrePO: "",
      filtreLieuDepart: "",
      filtreLieuArrivee: "",

      afficherFluxPrevisionnels: true,
      afficherFluxOuverts: true,
      afficherFluxFermes: false,
      afficherFluxAnnules: true,
      dialogFermetureFlux: false,
      fermerFeuilleRouteDateArrivee: new Date().toISOString().substr(0, 10),
      menuDateArrivee: false,

      dialogSuppressionFlux: false,
      
      alertesInfos: [],
      alertesInfosIndex: 0,
      dialogAi: false,
      prioriteAi: 0,
      headersAi: [
        { text: this.$tr.purchaseOrder.aic1, value: 'aiDate' }, //Date
        { text: this.$tr.purchaseOrder.aic2, value: 'aiAuteur'}, //Auteur
        { text: this.$tr.purchaseOrder.aic3, value: 'aiPriorite'}, //Priorité
        { text: this.$tr.purchaseOrder.aic4, value: 'aiMessage'}, //Message
        { text: this.$tr.purchaseOrder.aic5, value: 'aiDateEcheance'}, //Echéance
        { text: '', value: 'boutons'},
      ],
      dialogAjouterAi: false,
      alerteInfoMessage: "",
      datepickerAiEcheanceMenu: false,
      datepickerAiSEcheance: "",
      datepickerAiEcheance: "",

      trajets: [],
      gestionFluxPrevisionnelsPopup: false,
      poInclureWagonsVides: false

    }
  },

  created() {
    this.lireMotifsAnnulation()
  },

  mounted() {
    this.chargerFiltres()
    // Chargement des trajets mémorisés
    var t = localStorage.getItem("trajets");
    if ( (t == undefined) || (t == null) || (t == "")) {
      t = this.$user.user.trajets
    }
    if ( (t != undefined) && (t != null) && (t != "")) {
      this.trajets = JSON.parse(t)
    }
    var now = new Date();
    this.filtreDateFin = new Date(now.getTime() + 30 * 86400 * 1000).toISOString().substr(0, 10)
    this.filtreDateDebut = new Date(now.getTime() - 10 * 86400 * 1000).toISOString().substr(0, 10)
    this.lireLieus()

    setInterval(function() {
      this.alertesInfosIndex++
      if (this.alertesInfosIndex >= this.alertesInfos.length) {
        this.alertesInfosIndex = 0
      }
    }.bind(this), 4000)

    /*setTimeout(function() {
      window.addEventListener("resize", this.redimensionnerApplication.bind(this));
      this.redimensionnerApplication()
    }.bind(this), 100)*/
    window.addEventListener('resize', this.handleWindowResize);
    //console.log("$el",this.$el.getBoundingClientRect().width, this.$el.getBoundingClientRect().height)
    //console.log("window", window.getBoundingClientRect().width, window.getBoundingClientRect().height)
    setTimeout(function() {
      this.handleWindowResize()
    }.bind(this))
  },

  beforeDestroy: function () {
    window.removeEventListener('resize', this. handleWindowResize)
  },

  methods: {

     handleWindowResize() {
      const s = this.$refs.vuepo.getBoundingClientRect();
      const sW = s.width
      const sH = s.height
      const wW = window.innerWidth - 32;
      var wH = window.innerHeight - 170;
      var scaleX = wW / 1880;
      var scaleY = wH / 750;
      console.log(sW, sH, wW, wH)
      this.$refs.vuepo.style.transform = "scale(" + scaleX.toFixed(3) + ", " + scaleY.toFixed(3) + ")";      
      
    },    

    getIntItem(name, defaut) {
      const v = localStorage.getItem(name)
      if (v != null) {
        const vi = parseInt(v)
        if (!isNaN(vi)) {
          return vi
        }
      }
      return defaut
    },

    getStringItem(name, defaut) {
      const v = localStorage.getItem(name)
      if (v != null) {
        return v
      }
      return defaut
    },

    getBooleanItem(name, defaut) {
      const v = localStorage.getItem(name)
      if (v != null) {
        const vb = v.toLocaleLowerCase() == "true"
        return vb
      }
      return defaut
    },

    chargerFiltres() {
      this.filtreJoursAmont = this.getIntItem("filtreJoursAmont", -10)
      this.filtreJoursAval = this.getStringItem("filtreJoursAval", '+10')
      this.filtreTriDate = this.getStringItem("filtreTriDate", '2')
      this.afficherFluxPrevisionnels = this.getBooleanItem("afficherFluxPrevisionnels", false)
      this.afficherFluxOuverts = this.getBooleanItem("afficherFluxOuverts", false)
      this.afficherFluxFermes = this.getBooleanItem("afficherFluxFermes", false)
      this.afficherFluxAnnules = this.getBooleanItem("afficherFluxAnnules", false)
    },

    enregistrerFiltres() {
      localStorage.setItem("filtreJoursAmont", this.filtreJoursAmont)
      localStorage.setItem("filtreJoursAval", this.filtreJoursAval)
      localStorage.setItem("filtreTriDate", this.filtreTriDate)
      localStorage.setItem("afficherFluxPrevisionnels", this.afficherFluxPrevisionnels.toString())
      localStorage.setItem("afficherFluxOuverts", this.afficherFluxOuverts.toString())
      localStorage.setItem("afficherFluxFermes", this.afficherFluxFermes.toString())
      localStorage.setItem("afficherFluxAnnules", this.afficherFluxAnnules.toString())

    },

    lireLieus() {
      var url = "/api/liLieus?access_token=" + this.$user.id;
      axios.get(url)
        .then(function(response) {
          this.lieus = response.data
          this.rafraichirFeuillesRoute();
        }.bind(this))
    },

    lireMotifsAnnulation() {
      this.motifsAnnulation = Object.values(this.$tr.cancelReasons)
      //var url = "/api/maMotifAnnulations"
      //axios.get(url)
      //  .then(function(response) {
      //    this.motifsAnnulation = response.data
      //  }.bind(this))
    },

    getLieu(code) {
      const lieu = this.lieus.find(l => l.liCode == code)
      return lieu ? lieu.liDesignation : "?"
    },

    rechercherPurchaseOrder() {
      this.loading = true;
      var query = "dateDebut=" + this.filtreDateDebut.substr(0, 10)
      query += "&dateFin=" + this.filtreDateFin.substr(0, 10)
      query += "&inclureWagonsVides=" + this.poInclureWagonsVides
      if ((this.filtreProduit != "") && (this.filtreProduit != null)) {
        query += "&produit=" + this.filtreProduit
      }
      if ((this.filtrePO != "") && (this.filtrePO != null)) {
        query += "&numero=" + this.filtrePo
      }
      axios.get("/api/caCodeArticles/rechercherPurchaseOrder?" + query)
      //axios.get("/api/poPurchaseOrders?filter=" + encodeURIComponent(JSON.stringify(filter)) + "&access_token=" + this.$user.id)
      .then(function (response) {
        response.data.forEach(data => {
          data.frDepartDateTheorique = this.formatDateISO(data.frDepartDateTheorique)
          data.frDepartDateReelle = this.formatDateISO(data.frDepartDateReelle)
          data.frArriveeDateTheorique = this.formatDateISO(data.frArriveeDateTheorique)
          data.frArriveeDateReelle = this.formatDateISO(data.frArriveeDateReelle)
        })
        this.purchaseOrders = response.data
        this.loading = false;
      }.bind(this))
      .catch(error => {
        if (error.response.status == 401) {
          // Erreur "accès refusé", redirection vers la page de connexion
          this.afficherErreur(this.$tr.errorCommon.accessDenied);
          this.purchaseOrders = [];
          //this.$router.push('/login?to=/containers')
        }
        else {
          this.afficherErreur(error.message + " : " + error.response.statusText)
          this.purchaseOrders = [];
        }
      });
    
    },

    afficherErreur(message) {
      this.snackMessage = message;
      this.snackErreur = true
      this.loading = false;
    },

    boutonRechercherPurchaseOrderClick() {
      this.rechercherPurchaseOrder();
    },

    boutonExporterPurchaseOrderClick() {
      try {
        json2excel({
            data: this.purchaseOrders,
            name: 'purchase-orders',
            formateDate: 'yyyy/mm/dd'
        });
      } catch (e) {
          console.error('export error');
      }
    },

    getColor(niveau) {
      switch(niveau) {
        case 0: return 'green';
        case 1: return 'orange';
        case 2: return 'red';
      }
      return 'grey'
    },

    /**
     * Couleur du cadre de la feuille de route = f(statut)
     * @param {Object} fr 
     */
    getFrColor(fr) {
      //console.log(fr)
      switch(fr.frStatut) {
        case 0: return "white"              // Prévisionnel
        case 1: return 'blue lighten-3'     // Couvert
        case 2: return 'yellow lighten-3'   // Ouvert
        case 3: return 'green lighten-3'    // Fermé ok
        case 4: return 'red'                // Annulé
      }
      return 'orange'
    },

    async rafraichirFeuillesRoute() 
    {
      this.enregistrerFiltres();

      this.loading = true;
      const now = new Date()
      var dAmont = new Date(now.getTime() + (this.filtreJoursAmont * 24 * 3600 * 1000))
      var sdAmont = dAmont.toISOString().substr(0, 10);
      var dAval = new Date(now.getTime() + (parseInt(this.filtreJoursAval) * 24 * 3600 * 1000))
      var sdAval = dAval.toISOString().substr(0, 10);
      var filter = {
        "where": {
          "and": [
            {
              "frDepartDateTheorique": {
                "gt": sdAmont
              }
            },
            {
              "frArriveeDateTheorique": {
                "lt": sdAval
              }
            }
          ]
        },
        "include": [
          "po", 
          "tr", 
          "wg",
          {"relation": "nt", "scope": {"order": "ntDateCreation DESC"}}
        ],
        "order": ["frDepartDateTheorique " + (this.filtreTriDate == '1' ? "DESC" : "ASC"), "frArriveeDateTheorique " + (this.filtreTriDate == '1' ? "DESC" : "ASC")]
      }
      if (this.referenceRecherchee != "") {
        filter.where.and.push({
          "frReference": {
            "like": "%" + this.referenceRecherchee + "%"
          }
        })
      }
      var filtreStatut = []
      if (this.afficherFluxPrevisionnels) {
        filtreStatut.push({"frStatut": this.$FLUX_STATUT_PREVISIONNEL})
        filtreStatut.push({"frStatut": this.$FLUX_STATUT_COUVERT})
      }
      if (this.afficherFluxOuverts) { 
        filtreStatut.push({"frStatut": this.$FLUX_STATUT_OUVERT})
      }
      if (this.afficherFluxFermes) {
        filtreStatut.push({"frStatut": this.$FLUX_STATUT_FERME})
      }
      if (this.afficherFluxAnnules) {
        filtreStatut.push({"frStatut": this.$FLUX_STATUT_ANNULE})
      }
      if (filtreStatut.length > 0) {
        filter.where.and.push({"or": filtreStatut})
      }
      else {
        filter.where.and.push({"frStatut": -1})
      }

      const lieuDepartRecherchee = this.getField(this.lieuDepartRecherchee)
      if (lieuDepartRecherchee != "") {
        var liste = lieuDepartRecherchee.split(" ")
        if (liste.length == 1) {
          // Un seul lieu de départ
          filter.where.and.push({
            "frDepartLieu": {
            "like": "%" + lieuDepartRecherchee.toUpperCase() + "%"
            }
          })
        }
        else {
          // Plusieurs lieus de départ
          var filtreOu = []
          liste.forEach(lieu => filtreOu.push({"frDepartLieu": {"like": "%" + lieu.toUpperCase() + "%"}}))
          var filtreLieus = {
            "or": filtreOu
          }
          filter.where.and.push(filtreLieus);
        }
      }

      const lieuArriveeRecherchee = this.getField(this.lieuArriveeRecherchee)
      if (lieuArriveeRecherchee != "") {
        liste = lieuArriveeRecherchee.split(" ")
        if (liste.length == 1) {
          // Un seul lieu de départ
          filter.where.and.push({
            "frArriveeLieu": {
            "like": "%" + lieuArriveeRecherchee.toUpperCase() + "%"
            }
          })
        }
        else {
          // Plusieurs lieus de départ
          filtreOu = []
          liste.forEach(lieu => filtreOu.push({"frArriveeLieu": {"like": "%" + lieu.toUpperCase() + "%"}}))
          filtreLieus = {
            "or": filtreOu
          }
          filter.where.and.push(filtreLieus);
        }
      }

      // Mémorisation éventuel du trajet
      if ((lieuDepartRecherchee != "") || (lieuArriveeRecherchee != "")) {
        const trajet = lieuDepartRecherchee  + " -> " + lieuArriveeRecherchee
        if (this.trajets.indexOf(trajet) < 0) {
          this.trajets.push(trajet)
          localStorage.setItem("trajets", JSON.stringify(this.trajets))
          this.sauvegarderTrajetsBdd()
        }
      }

      await axios.get("/api/frFeuilleRoutes?filter=" + encodeURIComponent(JSON.stringify(filter)) + "&access_token=" + this.$user.id + "&time=" + new Date().getTime())
      .then(function (response) {
        response.data.forEach(function(fr) { 
          fr.statutCouvert = fr.frStatut == this.$FLUX_STATUT_COUVERT
          fr.statutLoading = false
        }.bind(this))
        this.frs = response.data
        this.loading = false;
      }.bind(this))
      .catch(error => {
        if (error.response.status == 401) {
          // Erreur "accès refusé", redirection vers la page de connexion
          this.afficherErreur(this.$tr.errorCommon.accessDenied);
          this.flux = [];
          //this.$router.push('/login?to=/containers')
        }
        else {
          this.afficherErreur(error.message + " : " + error.response.statusText)
          this.flux = [];
        }
      });

      this.lireAlertesInfos();

    },

    getField(value) {
      if ((value == null) || (value == undefined)) {
        return ""
      }
      if (value.trim) {
        return value.trim()
      }
      return ""
    },
    
    async lireAlertesInfos() {
      // Rafraichissement des alertes infos
      const tri = {"order": ["aiPriorite DESC", "aiDateEcheance DESC"]}
      axios.get("/api/aiAlerteInfos?filter=" + JSON.stringify(tri))
      .then(function (response) {
        this.alertesInfos = response.data
        //console.log("this.alertesInfos", this.alertesInfos)
      }.bind(this))
      .catch(error => {
        if (error.response.status == 401) {
          // Erreur "accès refusé", redirection vers la page de connexion
          this.afficherErreur(this.$tr.errorCommon.accessDenied);
          this.alertesInfos = [];
          //this.$router.push('/login?to=/containers')
        }
        else {
          this.afficherErreur(error.message + " : " + error.response.statusText)
          this.alertesInfos = [];
        }
      });       
    },

    async supprimerAlerteInfo(aiAiId) {
      // Suppression de l'alerte info
      axios.delete("/api/aiAlerteInfos/" + aiAiId)
      .then(function () {
        this.lireAlertesInfos();
      }.bind(this))
      .catch(error => {
        if (error.response.status == 401) {
          // Erreur "accès refusé", redirection vers la page de connexion
          this.afficherErreur(this.$tr.errorCommon.accessDenied);
          //this.$router.push('/login?to=/containers')
        }
        else {
          this.afficherErreur(error.message + " : " + error.response.statusText)
        }
      });       
    },

    async lirePo(flux) 
    {
      // Mise à jour par rapport à la présence des wagons de chaque PO
      const liste = flux.po
      liste.forEach(po => {
        const wg = flux.wg.find(w => w.wgNumero == po.poNumeroWagon)
        po.wgPresent = wg ? wg.wgPresent : undefined
      })
      this.poliste = liste;
      this.dialogPo = true;
    },

    async lireWagons(fr) 
    {
      this.wagons = fr.wg
      this.dialogWagons = true;
    },

    formatDateISO(date) {
      if (date == undefined) {
        return ""
      }
      return date.substr(0,10).replace(/-/g,'/')
      //const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
      //const event = new Date(date)
      //return this.moment(new Date(date), 'YYYY-MM-DD')
      //return event.toLocaleDateString('fr-Fr', options)
    },

    formatDate(date) {
      if (date == undefined) {
        return ""
      }
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      const event = new Date(date)
      return event.toLocaleDateString(this.$tr.locale, options)
    },

    formatDateHeure(date) {
      if (date == undefined) {
        return ""
      }
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      const event = new Date(date)
      return event.toLocaleDateString(this.$tr.locale, options) + " " + event.toLocaleTimeString()
    },

    formatHeure(date) {
      if (date == undefined) {
        return ""
      }
      const event = new Date(date)
      return event.toLocaleTimeString()
    },

    lienAfficheurSourceEvenement(trajet, eflx) {
      this.eflxSelectionne = eflx;
      axios.get("/api/eflxEvenementFluxes/lireSource?prestataire=" + trajet.ftPrestataire + "&source=" + eflx.eflxSource + "&access_token=" + this.$user.id)
        .then(function(response) {
          this.evenementSource = response.data
          console.log("evenementSource", this.evenementSource)
        }.bind(this))
      this.dialogSource = true;
    },

    copierTableauJsonEnCsv(tableau) {
      var fields = Object.keys(tableau[0])
      var replacer = function(key, value) { return value === null ? '' : value } 
      var csv = tableau.map(function(row){
        return fields.map(function(fieldName){
          return JSON.stringify(row[fieldName], replacer)
        }).join('\t')
      })
      csv.unshift(fields.join('\t')) // add header column
      csv = csv.join('\r\n');
      navigator.clipboard.writeText(csv);
      //this.copyToClipBoard(csv);
      //window.prompt("Appuyer sur Ctrl-C pour copier dans le presse-papier puis cliquer sur Ok", csv);
    },

    boutonVoirLeFluxClick(flux) {
      this.referenceRecherchee = flux.flxReference;
      this.tab = 0
      this.rafraichirFeuillesRoute()
    },

    copyToClipBoard(text) {
        var input = document.createElement('textarea');
        input.innerHTML = text;
        document.body.appendChild(input);
        input.select();
        console.log("*",text)
        setTimeout(function() {
          document.execCommand('copy');
          console.log("B")
          document.body.removeChild(input);
          this.snackClipbaord = true;

        }.bind(this), 250)
    },

    calculerCouleurWagonPresent(wgPresent) {
      switch(wgPresent) {
        case 0: return 'red'
        case 1: return 'green'
      }
      return "#C0C0C0"
    },

    calculerCouleurControleWagons(controleWagonsOk) {
      switch(controleWagonsOk) {
        case 0: return 'red'
        case 1: return 'green'
      }
      return "#C0C0C0"
    },

    calculerClasseDateReelle(dateTheorique, dateReelle, dureeAlerte1 = 24, dureeAlerte2 = 48, dureeAlerte3 = 72) {
      if ((dateTheorique == undefined) || (dateReelle == undefined)) {
        return 'dateReelleIndefinie'
      }
      try {
        const d1 = new Date(dateTheorique)
        const d2 = new Date(dateReelle)
        // Alerte 1
        const dureeAlerte1ms = dureeAlerte1 * 3600 * 1000
        const dureeAlerte2ms = dureeAlerte2 * 3600 * 1000
        const dureeAlerte3ms = dureeAlerte3 * 3600 * 1000
        if (d2.getTime() > (d1.getTime() + dureeAlerte3ms)) {
          return 'dateReelleAlerte3'
        }
        if (d2.getTime() > (d1.getTime() + dureeAlerte2ms)) {
          return 'dateReelleAlerte2'
        }
        if (d2.getTime() > (d1.getTime() + dureeAlerte1ms)) {
          return 'dateReelleAlerte1'
        }
          return 'dateReelleOk'
      }
      catch(error) {
        console.log("error", error)
        'dateReelleIndefinie'
      }
    },

    ajouterModifierNoteClickHandler(event, nt, frId) {
      this.$refs.editNote.ouvrir(nt, frId)
      event.stopPropagation()
    },

    nodeCreeeEventHandler(event) {
      const fr = this.frs.find(f => f.frId == event.ntFrId)
      fr.nt.push(event)
      //this.rafraichirFeuillesRoute()
    },
    
    nodeModifieeEventHandler(event) {
      const fr = this.frs.find(f => f.frId == event.ntFrId)
      if (fr) {
        const nt = fr.nt.find(n => n.ntId == event.ntId)
        if (nt) {
          const idxNt = fr.nt.indexOf(nt)
          fr.nt[idxNt] = event
          nt.node = event.ntNote;
          const idxFr = this.frs.indexOf(fr)
          Vue.set(this.frs, idxFr, fr )
        }
      }
      //this.rafraichirFeuillesRoute()
    },

    supprimerNoteClickHandler(ntId) {
      if (confirm(this.$tr.editNote.confirmDelete)) {
        axios.delete("/api/ntNotes/" + ntId)
          .then(function() {
            this.rafraichirFeuillesRoute()            
          }.bind(this))      
      }
    },

    lireTrajet(depart, arrivee) {
      let trajet = ""
      const ldepart = this.lieus.find(l => l.liCode == depart)
      if (ldepart) {
        trajet =  ldepart.liDesignation
      }
      let larrivee = this.lieus.find(l => l.liCode == arrivee)
      if (larrivee) {
        trajet += " - "  + larrivee.liDesignation
      }
      return trajet;
    },

    importerFeuillesRoute() {
      this.$refs.importerPopup.open()
    },

    fermerFeuilleRouteClickHandler(fr) {
      this.fermerFeuilleRouteDateArrivee = fr.frArriveeDateTheorique.substr(0, 10)
      this.$refs.modifierFluxPopup.motifsAnnulation = this.motifsAnnulation
      this.$refs.modifierFluxPopup.motifAnnulation = ""
      this.$refs.modifierFluxPopup.open(fr)
      //this.dialogFermetureFlux = true
    },

    
    computeNbAlertesInfos(alertesInfos) {
      if ((alertesInfos == undefined) || (alertesInfos.length == 0)) {
        return this.$tr.purchaseOrder.alertInfo;
      }
      return alertesInfos.length == 1 ? this.$tr.purchaseOrder.alertInfo : alertesInfos.length.toString() + " " + this.$tr.purchaseOrder.alertsInfos;
    },

    ajouterAlerteInfoClickHandler() {
      this.dialogAjouterAi = true;
      const now = new Date();
      const echeance = new Date(now.getTime() + 3 * 86400 * 1000)
      this.datepickerAiSEcheance = echeance.toISOString().substr(0, 10)
      this.datepickerAiEcheance = echeance.toISOString().substr(0, 10)
      setTimeout(function() {
        this.$refs.refAlerteInfoMessage.$el.querySelector("input").value = ""
        this.$refs.refAlerteInfoMessage.focus();
      }.bind(this), 200)
    },

    validerAlerteInfoClickHandler() {
      const texteAlerte = this.$refs.refAlerteInfoMessage.$el.querySelector("input").value
      if (texteAlerte.trim() == "") {
        alert(this.$tr.purchaseOrder.alertCantBeEmpty);
        return;
      }
      // Ajout de l'alerte info
      let body = {
        aiMessage: texteAlerte,
        aiAuteur: this.$user.user.username,
        aiDateEcheance: this.datepickerAiEcheance,
        aiPriorite: this.prioriteAi
      }
      axios.post("/api/aiAlerteInfos", body)
      .then(function () {
        this.lireAlertesInfos();
        this.dialogAjouterAi = false;
      }.bind(this))
      .catch(error => {
        if (error.response.status == 401) {
          // Erreur "accès refusé", redirection vers la page de connexion
          this.afficherErreur(this.$tr.errorCommon.accessDenied);
          //this.$router.push('/login?to=/containers')
        }
        else {
          this.afficherErreur(error.message + " : " + error.response.statusText)
        }
      });       
    }, 

    choixJourDateEchanceAlerteInfo() {
      this.datepickerAiEcheanceMenu = false
      this.datepickerAiSEcheance = this.parseDate(this.datepickerAiEcheance);
    },

    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('-')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    test1(e) {
      console.log(e)
    },

    rafraichirTrajet(trajet) {
      this.menuTrajets = false
      if (trajet != "") {
        const f = trajet.split("->")
        this.lieuDepartRecherchee = f[0].trim().toUpperCase()
        if (f.length > 1) {
          this.lieuArriveeRecherchee = f[1].trim().toUpperCase()          
        }
        else {
          this.lieuArriveeRecherchee = ""
        }
        this.rafraichirFeuillesRoute()
      }
    },

    supprimerTrajet(trajet) {
      const idx = this.trajets.indexOf(trajet)
      if (idx >= 0) {
        this.trajets.splice(idx, 1)
        localStorage.setItem("trajets", JSON.stringify(this.trajets))
        this.sauvegarderTrajetsBdd()
      }
    },

    monterTrajet(trajet) {
      const idx = this.trajets.indexOf(trajet)
      if (idx > 0) {
        const temp = this.trajets[idx]
        this.trajets[idx] = this.trajets[idx - 1]
        this.trajets[idx - 1] = temp
        localStorage.setItem("trajets", JSON.stringify(this.trajets))
        this.sauvegarderTrajetsBdd()
        this.trajets = JSON.parse(JSON.stringify(this.trajets))
      }
    },

    descendreTrajet(trajet) {
      const idx = this.trajets.indexOf(trajet)
      if (idx < this.trajets.length - 1) {
        const temp = this.trajets[idx]
        this.trajets[idx] = this.trajets[idx + 1]
        this.trajets[idx + 1] = temp
        localStorage.setItem("trajets", JSON.stringify(this.trajets))
        this.sauvegarderTrajetsBdd()
        this.trajets = JSON.parse(JSON.stringify(this.trajets))
      }
    },

    /**
     * Sauvegarder les filtres de trajets dans la base de données centrale
     */
    sauvegarderTrajetsBdd() {
      const url = "/api/wdUsers/" +this.$user.userId + "?access_token=" + this.$user.id
      const body = {"trajets": JSON.stringify(this.trajets)}
      axios.patch(url, body)
        .then(function(response) {
          if (this.$user.upId == undefined) {
            this.$user.upId = response.upId
          }
        }.bind(this))
    },

    /**
     * Evènement déclenché par le popup de modification d'un flux
     */
    fluxmodifieEventHandler() {
      this.rafraichirFeuillesRoute()
    },

    boutonOuvrirFluxPrevisionnelsClickEventHandler() {
      this.$refs.gestionFluxPrevisionnelsPopup.open();
    },

    boutonChercherCodesArticles(po) {
      const filter = {
        "where": {
          "or": [
            {"caPoNumero": po.poNumero},
            {"caNumeroBesoin": po.poNumero}
          ]
        }
      }
      this.caLoading = true;
      const url = "/api/caCodeArticles?access_token=" + this.$user.id + "&filter=" + JSON.stringify(filter);
      axios.get(url)
        .then(function(response) {
          this.caLoading = false;
          this.caliste = response.data
          this.dialogCa = true
        }.bind(this))
        .catch(function() {
          this.caLoading = false;
        }.bind(this))
    },

    boutonToutFiltreStatut() {
      this.afficherFluxPrevisionnels = true
      this.afficherFluxOuverts = true
      this.afficherFluxFermes = true
      this.afficherFluxAnnules = true
      this.rafraichirFeuillesRoute()
    },

    boutonAucunFiltreStatut() {
      this.afficherFluxPrevisionnels = false
      this.afficherFluxOuverts = false
      this.afficherFluxFermes = false
      this.afficherFluxAnnules = false
    },

    boutonFluxCouvert(event, fr, indexFr) {
      event.stopPropagation()
      fr.statutLoading = true
      console.log("bouton", event, fr.statutCouvert)
      const url = "/api/frFeuilleRoutes/" + fr.frId + "?access_token=" + this.$user.id;
      const body = {
        frStatut: fr.statutCouvert ? this.$FLUX_STATUT_COUVERT : this.$FLUX_STATUT_PREVISIONNEL
      }
      axios.patch(url, body)
        .then(function() {
          fr.statutLoading = false
          fr.frStatut = fr.statutCouvert ? this.$FLUX_STATUT_COUVERT : this.$FLUX_STATUT_PREVISIONNEL
          fr.frStatutCouvert = fr.frStatut == this.$FLUX_STATUT_COUVERT
          Vue.set(this.frs, indexFr, fr)
        }.bind(this))
        .catch(error => {
          fr.statutLoading = false
          if (error.response.status == 401) {
            // Erreur "accès refusé", redirection vers la page de connexion
            this.afficherErreur(this.$tr.errorCommon.accessDenied);
            //this.$router.push('/login?to=/containers')
          }
          else {
            this.afficherErreur(error.message + " : " + error.response.statusText)
          }
        })
    },

    computeWagonNOK(fr) {
      var ok = true
      fr.tr.forEach(t => ok = ok && t.trControleWagonsOk)
      return !ok
    }


  }
}
</script>

<style scoped>

div > * {
    vertical-align: middle;  
}

.v-application--is-ltr .v-input--selection-controls__input {
    margin-right: 0px !important;
}

.filtreTexteStatut {
  font-size: 14px;
  color: white;
}
.motifAnnulation {
  color: white;
  padding: 5px;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.text-field input{
  color: white !important;
}
.v-data-table >>> .v-data-table__wrapper > table {
  width: auto !important;
  border-collapse:separate;
  border-spacing:0 5px;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th,td {
  text-align: center !important;
}


.titreValeur {
  color: #0c4878;
  font-size: 16px;
  margin-bottom: 5px;
  width: 100%;
  text-align: center;
}

.dateReelle {
  border: 1px solid lightgrey;
  padding: 5px;
  /*min-height: 50px;*/
  width: 320px;
  text-align: center;
  font-size: 18px;
}

.dateReelleOk {
  color: black;
  background-color: #00FF00;
}

.dateReelleIndefinie {
  color: black;
  background-color: lightgrey;
}

.dateReelleAlerte1 {
  color: black;
  background-color: yellow;
}

.dateReelleAlerte2 {
  color: black;
  background-color: orange;
}

.dateReelleAlerte3 {
  color: white;
  background-color: red;
}

.note {
  border: 1px solid #C0C0C0;
  flex: 1;
  padding: 5px;
}

.blink_me {
  animation: blinker 5s step-start infinite;
  background-color: red !important;
  color: white;
}

@keyframes blinker {
  10% {
    opacity: 0;
  }
}
</style>